import { Button, FileIconComponent, Tooltip } from "@synthesis/shared-ui";
import { cn } from "@synthesis/shared-utils";

import type { CreateApplicationDocumentTableRow, CreateApplicationDocumentUploadHandlers } from "../../create-application-page.lib";
import { CreateApplicationInfoMark } from "../create-application-info-mark";
import { IconBin } from "@synthesis/shared-icons";

type CreateApplicationDocumentRowProps = CreateApplicationDocumentTableRow & CreateApplicationDocumentUploadHandlers;

const getFileExtension = (fileName: string) => {
  const parts = fileName.split(".");
  return parts.length > 1 ? (parts.at(-1) ?? "") : "";
};

export const CreateApplicationDocumentRow = ({
  id,
  order,
  title,
  required,
  hint,
  uploadedFiles,
  showValidationError,
  onUploadClick,
  onRemoveFile,
}: CreateApplicationDocumentRowProps) => {
  return (
    <div className="flex w-full items-stretch" data-create-application-invalid={showValidationError ? "true" : undefined}>
      <div className="border-neutrals-90 bg-neutrals-white flex w-12 shrink-0 flex-col self-stretch border-b px-4 py-3">
        <span className="paragraph-sm text-type-common whitespace-nowrap">{order}</span>
      </div>

      <div className="border-neutrals-90 bg-neutrals-white flex min-w-0 flex-1 items-start gap-2 border-b px-4 py-3">
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <div className="flex min-w-0 items-start gap-2">
            {hint ? (
              <CreateApplicationInfoMark description={hint} ariaLabel="Показать подсказку о документе" maxWidth="555px" className="mt-px" />
            ) : null}
            <p className={cn("paragraph-sm text-type-common min-w-0 whitespace-normal", showValidationError && "text-system-error-50")}>
              {required && <span className="text-system-error-50">* </span>}
              {title}
            </p>
          </div>

          {uploadedFiles.length > 0 && (
            <div className="flex w-fit min-w-0 max-w-full flex-col gap-1">
              {uploadedFiles.map((uploadedFile) => {
                const normalizedFileName = uploadedFile.fileName.trim();

                return (
                  <div
                    key={uploadedFile.key}
                    className="hover:bg-neutrals-95 group-focus-within:bg-neutrals-95 group flex w-fit min-w-0 max-w-full items-center gap-2 overflow-hidden rounded-sm p-0.5 transition-colors"
                  >
                    <FileIconComponent className="size-6 shrink-0" ext={getFileExtension(normalizedFileName)} />
                    <div className="min-w-0 flex-1 overflow-hidden">
                      <Tooltip description={normalizedFileName}>
                        <span className="paragraph-sm text-system-info-50 block truncate">{normalizedFileName}</span>
                      </Tooltip>
                    </div>
                    <Button
                      type="button"
                      theme="text"
                      size="xs"
                      className="shrink-0 opacity-0 transition-opacity group-focus-within:opacity-100 group-hover:opacity-100"
                      onClick={() => onRemoveFile(id, uploadedFile.key)}
                      icon={<IconBin className="size-5" />}
                    />
                  </div>
                );
              })}
            </div>
          )}

          {showValidationError && <span className="text-system-error-50 paragraph-sm">Загрузите обязательный документ</span>}
        </div>

        <Button type="button" theme="secondary" size="sm" className="shrink-0" onClick={() => onUploadClick(id)}>
          Загрузить файл
        </Button>
      </div>
    </div>
  );
};
